import React, { FC, PropsWithChildren, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Box } from '@mui/material';

interface ModalPortalProps extends PropsWithChildren { }

const ModalPortal: FC<ModalPortalProps> = ({ children }) => {
  // Prevents scrolling behind the modal prompt
  // Triggers on component render
  // on component cleanup returns previous overflow
  useEffect(() => {
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    if (html) {
      html.style.overflow = 'hidden';
      html.style.height = '100vh';
    }
    if (body) {
      body.style.overflow = 'hidden';
      body.style.height = '100vh';
    }
    return () => {
      if (html) {
        html.style.overflow = 'unset';
        html.style.height = 'unset';
      }
      if (body) {
        body.style.overflow = 'unset';
        body.style.height = 'unset';
      }
    };
  }, []);

  const modalDiv = document.getElementById("modals");

  return (
    createPortal(
      <Box
        sx={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backdropFilter: "blur(18px)",
          zIndex: 1299,
        }}>
        {children}
      </Box>,
      modalDiv!
    )
  )
}

export default ModalPortal;
